import { UseQueryResult, useQuery } from "@tanstack/react-query";
import NotificationMediumValuesResponse from "../../../models/API/responseModels/notificationMediumValuesResponse.model";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";

function useMediumValues(): UseQueryResult<NotificationMediumValuesResponse> {
  const { authState } = useOktaAuth();
  return useQuery({
    queryKey: ["notificationMediums"],
    queryFn: () =>
      axiosInstance
        .get("/v1/notification-mediums", {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
        })
        .then((res) => res.data),
    enabled: !!authState?.accessToken?.accessToken,
  });
}

export default useMediumValues;
